import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Container,
  Pagination,
  Tooltip,
  Checkbox,
  Divider,
} from "@mui/material";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from "../../custom-components/CommonDownload";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useLocation, useNavigate } from "react-router-dom";
import CodeEditor from "./CodeEditorForAPITesting";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import CommonCopy from "../../custom-components/CommonCopy";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";

// const FeatureFile = ({
//   title,
//   isChecked,
//   isExpanded,
//   onCheckboxToggle,
//   onExpandToggle,
// }) => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         padding: "8px 8px",
//         backgroundColor: isChecked ? "#b3d1ff" : "white",
//         marginLeft: "-10px",
//         marginRight: "-40px",
//         marginBottom: "2px",
//       }}
//     >
//       <Box sx={{ display: "flex", alignItems: "center" }}>
//         <IconButton onClick={onExpandToggle}>
//           {" "}
//           {/* Use the prop to toggle expand/collapse */}
//           {isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
//         </IconButton>
//         <Checkbox checked={isChecked} onChange={onCheckboxToggle} />
//         <Typography variant="body2" sx={{ flexGrow: 1 }}>
//           {title}
//         </Typography>
//       </Box>
//       {isExpanded && (
//         <>
//           <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.1)", my: 2 }} />
//         </>
//       )}
//     </Box>
//   );
// };

const FeatureFileAPI = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isDisabled = true;
  const [featureFileData, setfeatureFileData] = useState(props.featureFileData);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [pojoData, setPojoData] = useState("intro");

  const [activeThumb, setActiveThumb] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const defaultLocatorsExpanded =
    props.featureFileData !== "" && props.confirmed === false;

      useEffect(() => { 
        if (props.featureFileData) {
          setfeatureFileData(props.featureFileData);
        }
      }, [props.featureFileData]);
    

  // console.log(props);

  const handleIntroduceSCHEMA = async () => {
        props.setConfirmed(true);
        props.setIntroduceSchema(true);
    navigate(`/dashboard/api-testing/${props.framework}/${props.projectType}`, {
      state: { ...location.state, pojoData: "", featureFileData: featureFileData,IntroduceSchema: true },
      replace: true,
    });
    // console.log("in schemaaaa");
    // props.setConfirmed(true);
  };
  const IconComponent = () => (
    <Box sx={{ maxWidth: 14, display: "flex", flexDirection: "column" }}>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/74001bbbe35d84ed7dd44adbf23d2273b030df4d38296f54b84768e53b777ae2?placeholderIfAbsent=true&apiKey=61dcb7c26aae4febb0f66efb27027a73"
        alt=""
        style={{ width: "100%", objectFit: "contain" }}
      />
    </Box>
  );
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };


  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  const handlePageSource = () => {
    navigate(location.pathname, {
      state: { ...location.state, pageSource: "" },
      replace: true,
    });
  };

  const handleDownload = () => {};
  const handleLike = () => {
    setLiked(!liked);
    if (disliked) setDisliked(false);
  };

  const handleDislike = () => {
    setDisliked(!disliked);
    if (liked) setLiked(false);
  };

  const handleThumbClick = (thumbType) => {
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };

  return (
    <Box>
      <CommonAccordion
        summary={"Feature File"}
        details={
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 1,
              p: 2,
              marginTop: "-15px",
            }}
          >
            <CodeEditor
              codeContent={featureFileData}
              setCodeContent={setfeatureFileData}
            />

            <Container maxWidth={false} disableGutters>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="flex-start"
                maxWidth="557px"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                    marginTop: 2,
                  }}
                >
                  <Tooltip title="Like" arrow>
                    <Box
                      onClick={() => handleThumbClick("like")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#49A3FF", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "like" ? (
                        <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                      ) : (
                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                      )}
                    </Box>
                  </Tooltip>

                  <Tooltip title="Dislike" arrow>
                    <Box
                      onClick={() => handleThumbClick("dislike")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#FF4842", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "dislike" ? (
                        <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                      ) : (
                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                      )}
                    </Box>
                  </Tooltip>
                  <CommonCopy contentToCopy={featureFileData} />

                  {/* Copy Button with Tooltip */}
                  {/* <Tooltip title={isCopied ? "Copied!" : "Copy"} arrow>
                    <Box
                      // onClick={handleCopyClick}
                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          color: "#49A3FF", // Change color on hover
                        },
                      }}
                    >
                      {isCopied ? (
                        <ContentCopyIcon sx={{ fontSize: "24px" }} /> // Filled copy icon when copied
                      ) : (
                        <ContentCopyOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined copy icon by default
                      )}
                    </Box>
                  </Tooltip> */}
                </Box>
              </Box>
            </Container>
          </Box>
        }
        buttons={[
          {
            label: "Download",
            onClick: handleDownloadClick,
            variant: "text",
            startIcon: <SaveAltRoundedIcon />,
            sx: { textTransform: "none"},
          },
          {
            label: "Introduce Schema",
            onClick: handleIntroduceSCHEMA,
            variant: "contained",
            startIcon: <GenerateButtonIcon />,
            sx: { textTransform: "none", float: "right" },
          },
        ]}
        type={"output"}
        fullScreenMode={true}
        defaultExpanded={defaultLocatorsExpanded}
      />
      {/* {showPreferences && <SetPseudoCodePreferences />} */}

      <CommonDownload
        open={downloadOpen}
        onClose={handleCloseDownload}
        serviceResponse={[
          { heading: "Feature File", type: "text", data: featureFileData },
        ]}
        serviceName="Feature File"
        wordData={[
          { heading: "Feature File", type: "text", data: featureFileData },
        ]}
        documents={["docx", "pdf"]}
      />
    </Box>
  );
};

export default FeatureFileAPI;
